// extracted by mini-css-extract-plugin
module.exports = {"root":"FileBtn_root__2Kogr","disabled":"FileBtn_disabled__1N2BN","warn":"FileBtn_warn__29DnH","fade":"FileBtn_fade__2TPE4"};